import { useNotifier } from 'react-headless-notifier';
import {
  InfoAlert,
  ErrorAlert,
  SuccessAlert,
  WarningAlert,
} from '../components/shared/StyledAlerts';

export function useNotification() {
  const { notify } = useNotifier();

  function addNotification(
    type: 'info' | 'success' | 'warning' | 'error',
    message: string,
    title?: string
  ) {
    switch (type) {
      case 'success':
        notify(SuccessAlert({ title, message }));
        break;
      case 'error':
        notify(ErrorAlert({ title, message }));
        break;
      case 'warning':
        notify(WarningAlert({ title, message }));
        break;
      case 'info':
      default:
        notify(InfoAlert({ title, message }));
        break;
    }
  }

  return addNotification;
}
